module.exports = __webpack_public_path__ + "img/lores_text_box.ddea1eef.png";